import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import MedicalBoardHeroSection from '../MentalHealthMedicalBoardComponents/heroSection/MedicalBoardHeroSection'
import MedicalBoardGrid from '../MentalHealthMedicalBoardComponents/medicalBoardGrid/MedicalBoardGrid'
import { PublicAppFooter } from '../PublicAppFooter'
import PublicAppHeader from '../PublicAppHeader'
import { APP_CONSTANTS } from 'src/consumer/constants'

export default function MentalHealthMedicalBoard() {
  return (
    <>
      <PublicAppHeader config={{ showLinks: true }} />
      <SEOComponent
        title={'Mental Health Medical Board at AUMHUM'}
        description={
          'AUMHUM Mental Health Medical Board features leading psychiatrists, trainers, faculty, practitioners, and neurologists, ensuring top-quality mental health care and research.'
        }
        image={APP_CONSTANTS.MEDICAL_BOARD_IMAGE_LINK}
        keywordsArr={['Medical Board', 'Doctors', 'Health Experts']}
      />
      <MedicalBoardHeroSection
        title={'Mental Health Medical Board at AUMHUM'}
        description={
          'AUMHUM medical board consists of scientists, doctors and health experts, who peer-review and opine on evidence-based content you can trust. AUMHUM Mental Health Medical Board is comprised of leading figures in the mental health field, including distinguished psychiatrists, psychotherapy trainers, faculty members, practitioners, and neurologists.'
        }
        descriptionTwo={
          'Each member brings extensive expertise and a proven track record in mental health care, research, and education. This board plays a crucial role in guiding our mission to provide the highest quality mental health support and resources, ensuring evidence-based practices and innovative approaches to mental health treatment and awareness.'
        }
      />
      <MedicalBoardGrid />
      <PublicAppFooter />
    </>
  )
}
